import { render, staticRenderFns } from "./BgqwPage19.vue?vue&type=template&id=33249052"
import script from "./BgqwPage19.vue?vue&type=script&lang=js"
export * from "./BgqwPage19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports